export enum PlacementType {
  Auto = 'Auto',
  Top = 'Top',
  Left = 'Left',
  Right = 'Right',
  Bottom = 'Bottom'
}
